<div class="contentContainer guitarsContainer textColor">
	<h1 class="mat-display-3">Guitars Page...</h1>
	<img class="underConstruction" src="../../assets/images/under-construction.gif">
</div>
